var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllconsultant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#6842D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9264_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7636 37.1216C37.7636 33.5823 36.3853 30.255 33.8827 27.7524C33.207 27.0768 32.471 26.4839 31.6872 25.9772V30.7404C32.5373 31.07 33.1421 31.896 33.1421 32.8611C33.1421 34.115 32.1221 35.135 30.8682 35.135C29.6143 35.135 28.5944 34.115 28.5944 32.8611C28.5944 31.8721 29.2293 31.029 30.1126 30.7169V25.1058C29.9171 25.0146 29.7193 24.928 29.5195 24.8467C29.3648 24.9649 29.2058 25.0778 29.0427 25.1851L25.3008 30.4456V38.4999H37.7636V37.1216ZM27.1638 35.9839C26.7225 35.9839 26.3956 35.6232 26.3767 35.1966C26.3575 34.7715 26.7522 34.4093 27.1638 34.4093C27.6052 34.4093 27.9319 34.77 27.9511 35.1966C27.9703 35.6218 27.5756 35.9839 27.1638 35.9839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9922 25.1903C19.8264 25.0815 19.6649 24.9668 19.5075 24.8467C19.3918 24.8939 19.2764 24.9425 19.1619 24.9929V30.528C20.8887 30.9221 22.1813 32.4693 22.1813 34.3135V35.6988H20.6069V34.3135C20.6069 33.0403 19.571 32.0043 18.2977 32.0043C17.0243 32.0043 15.9883 33.0403 15.9883 34.3135V35.7825H14.4137V34.3135C14.4137 32.4147 15.784 30.8308 17.5875 30.4961V25.8212C16.7108 26.3609 15.8907 27.0063 15.1446 27.7524C12.642 30.255 11.2637 33.5825 11.2637 37.1216V38.4999H23.7263V30.4446L19.9922 25.1903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2827 26.3496C25.7126 26.4744 25.1207 26.541 24.5135 26.541C23.9072 26.541 23.3164 26.4746 22.7471 26.3502L24.5137 28.8372L26.2827 26.3496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8683 32.1621C30.4827 32.1621 30.1689 32.476 30.1689 32.8615C30.1689 33.2473 30.4827 33.561 30.8683 33.561C31.2539 33.561 31.5676 33.2471 31.5676 32.8615C31.5676 32.4758 31.2539 32.1621 30.8683 32.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5136 24.9137C28.2118 24.9137 31.2205 21.9052 31.2205 18.2069C31.2205 14.5087 28.2118 11.5 24.5136 11.5C20.8156 11.5 17.8066 14.5087 17.8066 18.2069C17.8066 21.9052 20.8154 24.9137 24.5136 24.9137Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9264_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(11 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllconsultant);
export default __webpack_public_path__ + "static/media/allconsultant.164f86b5819c4f38f425e978950a404f.svg";
export { ForwardRef as ReactComponent };